const Asterisk = () => <b style={{color: 'tomato', fontSize: '22px'}}>*</b>
export default Asterisk